import axios from 'axios';

export default function getCustomerBillingReports(config, params) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const url = config.getCustomerBillingReports;

  return dispatch => dispatch({
    type: 'BILLING_PRESIGNED_URL_FETCH',
    payload: axios({
      method: 'post',
      url,
      headers,
      data: JSON.stringify(params)
    })
  });
}


// WEBPACK FOOTER //
// ./src/actions/getCustomerBillingReports.js